<template>
  <div id="nav">
      <div class="left__nav">
          <router-link tag="a" to="/"><img src="../assets/logo.png" alt="logo"></router-link>
          <p>
              Вкус здоровой жизни
          </p>
      </div>
      <div class="right__nav">
        <div class="menu__r__nav">
            <router-link tag="a" to="/about">КОНТАКТЫ</router-link> |
            <router-link tag="a" to="/contractpayment">ДОСТАВКА И ОПЛАТА</router-link> |
            <router-link tag="a" to="/blogs">БЛОГ</router-link>
        </div>
        <p>
            <a href="tel:+77073049233">+7(707) 304 92 33</a>
        </p>
        <div class="right__nav__socials">
            <a href="">
                <span class="mdi mdi-instagram right__nav__socials_insta"></span>
            </a>
            <a href="">
                <span class="mdi mdi-whatsapp right__nav__socials_whatsapp"></span>
            </a>
            <a href="">
                <span class="mdi mdi-facebook right__nav__socials_facebook"></span>
            </a>
        </div>
      </div>
      <div class="right__nav_mob">
          <span @click="nav_mob_menu = true" class="mdi mdi-menu"></span>
      </div>
      <div v-show="nav_mob_menu" class="nav_mob_menu">
            <div class="nav_mob_menu_close">
                <span @click="nav_mob_menu = false" class="mdi mdi-close"></span>
            </div>
            <router-link v-on:click.native="nav_mob_menu = false" tag="a" to="/about">КОНТАКТЫ</router-link>
            <router-link v-on:click.native="nav_mob_menu = false" tag="a" to="/contractpayment">ДОСТАВКА И ОПЛАТА</router-link>
            <router-link v-on:click.native="nav_mob_menu = false" tag="a" to="/blogs">БЛОГ</router-link>
      </div>
  </div>
</template>

<script>

export default {
  name: 'Nav',
  data() {
    return {
      right__nav_mob: false,
      nav_mob_menu: false,
    };
  },
  methods: {
    localeWindow() {
        if (window.innerWidth < 900) {
            this.right__nav_mob = true
        }
    },
  },
  mounted() {
    this.localeWindow()
  },
}
</script>

<style scoped lang="less">
@baseMedia: 900px;
@font-face {
    font-family: 'Pattaya';
    src: url('../fonts/Pattaya-Regular.ttf');
}
#nav {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    display: flex;
    justify-content: space-between;
    .nav_mob_menu {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        z-index: 9999;
        background: url(../assets/meshok.jpg);
        .nav_mob_menu_close {
            width: 100%;
            padding-top: 7px;
            padding-bottom: 7px;
            margin-bottom: 20px;
            text-align: right;
            background: #668800;

            span {
                color: #fff;
                font-size: 45px;
                cursor: pointer;
                margin-right: 20px;
            }
        }
        a {
            width: 90%;
            display: block;
            padding-top: 7px;
            padding-bottom: 7px;
            color: white;
            background: #680;
            margin: 0 auto;
            text-align: center;
            margin-top: 1px;
            text-decoration: none;
            &:hover {
                background: #4d6700;
                cursor: pointer;
            }
        }
    }
    @media (max-width: @baseMedia) {
        width: 100%;
        flex-wrap: wrap;
    }
    .left__nav {
        width: 50%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media (max-width: @baseMedia) {
            width: 85%;
            padding-top: 5px;
        }
        img {
            margin-left: 10px;
            width: 139px;
            @media (max-width: @baseMedia) {
                width: 60px;
            }
        }
        p {
            font-size: 67px;
            margin-left: 15px;
            color: #5c6041;
            font-family: 'Pattaya';
            @media (max-width: @baseMedia) {
                font-size: 25px;
            }
        }
    }
    .right__nav_mob {
        width: 15%;
        justify-content: center;
        align-items: center;
        display: none;
        @media (max-width: @baseMedia) {
            display: flex;
        }
        span {
            cursor: pointer;
            font-size: 30px;
            color: #67644a;
            &:hover {
                opacity: 0.7;
            }
        }
    }
    .right__nav {
        width: 50%;
        text-align: right;
        display: block;
        @media (max-width: @baseMedia) {
            display: none;
        }
        .menu__r__nav {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-top: 15px;
            padding-bottom: 15px;
            a {
                color: #680;
                text-decoration: none;
                padding: 0px 15px;
            }
        }
        p  {
            padding: 0px 15px;
            font-weight: bold;
            cursor: pointer;
            font-size: 17px;
            a {
                text-decoration: none;
                color: #000;
                &:hover {
                    opacity: 0.9;
                }
            }
        }
        .right__nav__socials {
            display: flex;
            justify-content: flex-end;
            margin-right: 10px;
            margin-top: 10px;
            a {
                text-decoration: none;
                margin-left: 10px;
                span {
                    font-size: 25px;
                    &:hover {
                        opacity: 0.7;
                    }
                }
                .right__nav__socials_insta {
                    color: #d6249f;
                    color: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
                }
                .right__nav__socials_whatsapp {
                    color: #29a71a;
                }
                .right__nav__socials_facebook {
                    color: #3b5998;
                }
            }
        }
    }
}
</style>
